export const useTheme = () => {
  return { ns: 'ui-v3' };
};
